import { createAction, props } from '@ngrx/store';
import { ArkikProductResponse } from './arkik-products.models';

export const loadArkikProducts = createAction('[ArkikProducts] Load');

export const loadArkikProductsSuccess = createAction(
  '[ArkikProducts] Load Success',
  props<{ products: ArkikProductResponse[] }>(),
);

export const loadArkikProductsFailure = createAction('[ArkikProducts] Load Failure', props<{ error: string }>());

export const resetArkikProducts = createAction('[ArkikProducts] Reset');
export const refreshArkikProducts = createAction('[ArkikProducts] Refresh');
